import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", null, "口コミ投稿", -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode("正常に処理が完了しました")
const _hoisted_3 = { class: "formKitWrap" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "note" }, "500文字以内", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "note" }, "500文字以内", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h3", null, "5段階評価", -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode("はい")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("いいえ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("どちらとも思わない")
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", { class: "note" }, "500文字以内", -1)
const _hoisted_11 = /*#__PURE__*/_createTextVNode("投稿")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_alert = _resolveComponent("n-alert")!
  const _component_n_input = _resolveComponent("n-input")!
  const _component_n_form_item = _resolveComponent("n-form-item")!
  const _component_n_rate = _resolveComponent("n-rate")!
  const _component_n_radio = _resolveComponent("n-radio")!
  const _component_n_space = _resolveComponent("n-space")!
  const _component_n_form = _resolveComponent("n-form")!
  const _component_n_button = _resolveComponent("n-button")!
  const _component_n_layout = _resolveComponent("n-layout")!

  return (_openBlock(), _createBlock(_component_n_space, {
    vertical: "",
    style: {"padding":"10px"}
  }, {
    default: _withCtx(() => [
      _createVNode(_component_n_layout, { style: {"padding":"10px"} }, {
        default: _withCtx(() => [
          _hoisted_1,
          (_ctx.err)
            ? (_openBlock(), _createBlock(_component_n_alert, {
                key: 0,
                title: "失敗しました",
                type: "error",
                closable: "",
                style: {"margin-bottom":"10px"}
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.err), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.success)
            ? (_openBlock(), _createBlock(_component_n_alert, {
                key: 1,
                title: "成功しました",
                type: "success",
                closable: ""
              }, {
                default: _withCtx(() => [
                  _hoisted_2
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createElementVNode("p", null, "病院名: " + _toDisplayString(_ctx.hospitalName), 1),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_n_form, {
              model: _ctx.model,
              ref: "formRef",
              rules: _ctx.rules,
              class: "formKit"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_n_form_item, {
                  path: "startDate",
                  label: "ニックネーム"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_n_input, {
                      value: _ctx.model.nickname,
                      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.model.nickname) = $event)),
                      placeholder: " "
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_n_form_item, {
                  path: "startDate",
                  label: "病院名を正確に"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_n_input, {
                      value: _ctx.model.hospitalNameDetail,
                      "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.model.hospitalNameDetail) = $event)),
                      placeholder: " "
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_n_form_item, {
                  path: "option1",
                  label: "きっかけ・理由(本音ベースで)"
                }, {
                  default: _withCtx(() => [
                    _hoisted_4,
                    _createVNode(_component_n_input, {
                      value: _ctx.model.option1,
                      "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.model.option1) = $event)),
                      placeholder: " ",
                      type: "textarea"
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_n_form_item, {
                  path: "option2",
                  label: "実習を通しての感想"
                }, {
                  default: _withCtx(() => [
                    _hoisted_5,
                    _createVNode(_component_n_input, {
                      value: _ctx.model.option2,
                      "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.model.option2) = $event)),
                      placeholder: " ",
                      type: "textarea"
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_n_form_item, {
                  path: "startDate",
                  label: "実習開始日"
                }, {
                  default: _withCtx(() => [
                    _withDirectives(_createElementVNode("input", {
                      class: "n-input-like",
                      type: "date",
                      placeholder: " ",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.model.startDate) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.model.startDate]
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_n_form_item, {
                  path: "duration",
                  label: "期間"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_n_input, {
                      value: _ctx.model.duration,
                      "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.model.duration) = $event)),
                      placeholder: " "
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }),
                _hoisted_6,
                _createVNode(_component_n_form_item, {
                  path: "rating1",
                  label: "アクセス"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_n_rate, {
                      value: _ctx.model.rating1,
                      "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.model.rating1) = $event))
                    }, null, 8, ["value"]),
                    _createElementVNode("a", {
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.notReviewed('rating1')))
                    }, "無評価")
                  ]),
                  _: 1
                }),
                _createVNode(_component_n_form_item, {
                  path: "rating2",
                  label: "忙しさ"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_n_rate, {
                      value: _ctx.model.rating2,
                      "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.model.rating2) = $event))
                    }, null, 8, ["value"]),
                    _createElementVNode("a", {
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.notReviewed('rating2')))
                    }, "無評価")
                  ]),
                  _: 1
                }),
                _createVNode(_component_n_form_item, {
                  path: "rating3",
                  label: "院内の雰囲気"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_n_rate, {
                      value: _ctx.model.rating3,
                      "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.model.rating3) = $event))
                    }, null, 8, ["value"]),
                    _createElementVNode("a", {
                      onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.notReviewed('rating3')))
                    }, "無評価")
                  ]),
                  _: 1
                }),
                _createVNode(_component_n_form_item, {
                  path: "rating4",
                  label: "実習生に対する接し方"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_n_rate, {
                      value: _ctx.model.rating4,
                      "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.model.rating4) = $event))
                    }, null, 8, ["value"]),
                    _createElementVNode("a", {
                      onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.notReviewed('rating4')))
                    }, "無評価")
                  ]),
                  _: 1
                }),
                _createVNode(_component_n_form_item, {
                  path: "rating5",
                  label: "清潔感"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_n_rate, {
                      value: _ctx.model.rating5,
                      "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.model.rating5) = $event))
                    }, null, 8, ["value"]),
                    _createElementVNode("a", {
                      onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.notReviewed('rating5')))
                    }, "無評価")
                  ]),
                  _: 1
                }),
                _createVNode(_component_n_form_item, {
                  path: "rating6",
                  label: "獣医師看護師の仲の良さ"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_n_rate, {
                      value: _ctx.model.rating6,
                      "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.model.rating6) = $event))
                    }, null, 8, ["value"]),
                    _createElementVNode("a", {
                      onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.notReviewed('rating6')))
                    }, "無評価")
                  ]),
                  _: 1
                }),
                _createVNode(_component_n_form_item, { label: "今回の病院を友達に勧めようと思いますか？" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_n_space, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_n_radio, {
                          checked: _ctx.model.rating7 === 'yes',
                          onChange: _ctx.r7Handle,
                          value: "yes",
                          name: "rating7"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_7
                          ]),
                          _: 1
                        }, 8, ["checked", "onChange"]),
                        _createVNode(_component_n_radio, {
                          checked: _ctx.model.rating7 === 'no',
                          onChange: _ctx.r7Handle,
                          value: "no",
                          name: "rating7"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_8
                          ]),
                          _: 1
                        }, 8, ["checked", "onChange"]),
                        _createVNode(_component_n_radio, {
                          checked: _ctx.model.rating7 === 'unknown',
                          onChange: _ctx.r7Handle,
                          value: "unknown",
                          name: "rating7"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_9
                          ]),
                          _: 1
                        }, 8, ["checked", "onChange"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_n_form_item, {
                      path: "freeText",
                      label: "その他自由にお書きください"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_10,
                        _createVNode(_component_n_input, {
                          value: _ctx.model.freeText,
                          "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.model.freeText) = $event)),
                          placeholder: " ",
                          type: "textarea"
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model", "rules"]),
            _createVNode(_component_n_space, { justify: "center" }, {
              default: _withCtx(() => [
                _createVNode(_component_n_button, {
                  type: "primary",
                  onClick: _ctx.post,
                  loading: _ctx.loading
                }, {
                  default: _withCtx(() => [
                    _hoisted_11
                  ]),
                  _: 1
                }, 8, ["onClick", "loading"])
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}